import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { UserFilterComponent } from '../../abstract-user/user-filter/user-filter.component';
import { AdminDefinition } from '../../../../core/store/admin/admin-definitions/admin-definitions.interface';

@Component({
  selector: 'admin-eps-user-filter',
  templateUrl: './eps-user-filter.component.html',
  styleUrls: ['../../abstract-user/user-filter/user-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class EpsUserFilterComponent extends UserFilterComponent implements OnInit {
  @Input() isLoading: boolean;

  _salesOrganisations: AdminDefinition[];
  @Input()
  set salesOrganisations(adminDefinitions: AdminDefinition[]){
    this._salesOrganisations = adminDefinitions.map(def => {
      return {
        ...def,
        name: def.id + ' - ' + def.name
      }
    })
  }
  get salesOrganisations():AdminDefinition[] {
    return this._salesOrganisations;
  }

  constructor(formBuilder: UntypedFormBuilder) {
    super(formBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected getControlsConfig() {
    return Object.assign(super.getControlsConfig(), {
      isAdmin: [true],
      isNotAdmin: [true],
      canSeeHiddenMaterials:[true],
      cannotSeeHiddenMaterials:[true],
      canRelocate:[true],
      cannotRelocate:[true],
      canSelectDepot:[true],
      cannotSelectDepot:[true],
    });
  }

  filterClicked(): void {
    if (!this.isLoading) {
      this.filterUsers.emit(this.userFilterForm);
    }
  }
}
